module.exports = __webpack_public_path__ + "06_mustache_grey.7b79c2f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/06_mustache_grey.png
// module id = i9pG
// module chunks = 0